import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import TextHelper from '../../../../../../../core/helpers/TextHelper';
import { Block } from '../../../../../../components';
import ModalConfirmation from '../../../../components/Modal/Modal';
import Spinner from '../../../../../../components/Spinner';
import {
  ButtonBack,
  ContainerProcedure,
  SubContainer
} from '../../../certificates-constancies/type1/info/components';
import {
  TextTitle,
  ToggleHeader
} from '../../../certificates-constancies/type1/register/components';
import ConfirmationQuit from '../../UpdatePhoto/Register/components/ConfirmationQuit';
import Processing from '@/presentation/components/Processing';
import Step from '../../UpdatePhoto/Register/components/Step';
import { ProcedureInfoComponent } from '../info/components/ProcedureInfoComponent';
import { ConfirmRequestComponent, EnrolledComponent } from './components';
import RegisterForm from './components/RegisterForm';
import ContentModalOneButton from '../../../../components/ContentModalOneButton';
import iconError from '../../../../../../../assets/icons/illustration.svg';

interface ChangeStudiesOptionRegisterViewProps {
  procedureSelectedInfo: any;
  isProcessing: boolean;
  handlerChangeOption: (option: any) => void;
  selectedOption: any;
  handlerChangePeriod: (period: any) => void;
  selectedPeriod: any;
  handlerRequest: () => void;
  confirmRequest: boolean;
  setConfirmRequest: (option: any) => void;
  handlerCloseModalConfirmRequest: () => void;
  handlerSendData: () => void;
  optionsList: any[];
  isEnrolled: boolean;
  handleCloseModalIsInrolled: () => void;
  listCourses: any;
  handleCloseModalIsRequestLimit: () => void;
  isRequestLimit: boolean;
  handleCloseModalIsInrolledAndRequestLimit: () => void;
  isRequestLimitAndEnrollment: boolean;
  handlerChangeCampus: (campus: any) => void;
  selectedCampusData: any;
  isLoadingModalityOptionList: boolean;
  handlerChangeCycle: (option: any) => void;
  turnList: any;
  selectedTurn: any;
  isEntering: boolean;
  isRegisterError: boolean;
  handlerErrorClose: () => void;
}

const ChangeStudiesOptionRegisterView = (
  props: ChangeStudiesOptionRegisterViewProps
) => {
  const history = useHistory();
  const [showAlertBack, setShowAlertBack] = useState(false);
  const {
    procedureSelectedInfo,
    isProcessing,
    handlerChangeOption,
    handlerChangePeriod,
    selectedOption,
    selectedPeriod,
    handlerRequest,
    confirmRequest,
    setConfirmRequest,
    handlerCloseModalConfirmRequest,
    handlerSendData,
    isEnrolled,
    handleCloseModalIsInrolled,
    optionsList,
    listCourses,
    handleCloseModalIsRequestLimit,
    isRequestLimit,
    handleCloseModalIsInrolledAndRequestLimit,
    isRequestLimitAndEnrollment,
    handlerChangeCampus,
    selectedCampusData,
    isLoadingModalityOptionList,
    handlerChangeCycle,
    turnList,
    selectedTurn,
    isEntering,
    isRegisterError,
    handlerErrorClose
  } = props;
  const childContentComponent = (
    <ProcedureInfoComponent
      inRegister
      // applySince={procedureSelectedInfo?.detail?.applySince}
    />
  );
  const goBack = () => {
    if (selectedOption || selectedPeriod) {
      setShowAlertBack(true);
      return;
    }
    history.goBack();
  };
  const goToProcedureHome = () => history.push('/tramites');

  return (
    <ContainerProcedure data-testid="cmp-changeStudiesOptionRegisterView">
      {!procedureSelectedInfo && <Spinner />}
      {procedureSelectedInfo && (
        <SubContainer>
          <ButtonBack onClick={goBack} />
          <ToggleHeader
            name={procedureSelectedInfo?.name}
            amount={procedureSelectedInfo?.amount}
            duration={procedureSelectedInfo?.duration}
            date={procedureSelectedInfo?.endDate}
            // pin1={procedureSelectedInfo?.pin1}
            childContent={childContentComponent}
          />
          <TextTitle title="Progreso" />
          <Block
            customized
            // maxWidth={isMobile ? '100%' : '552px'}
            padding="28px 0px 45px 8px"
          >
            <Step
              name={procedureSelectedInfo?.steps[0]?.name}
              order={procedureSelectedInfo?.steps[0]?.order}
              isCurrent
            >
              <RegisterForm
                // procedureId={procedureSelectedInfo?.id}
                // modalityCodeCampus={
                //   procedureSelectedInfo?.detail?.currentAcademicData
                //     ?.studiesOption?.modalityCode
                // }
                selectedOption={selectedOption}
                selectedPeriod={selectedPeriod}
                selectedCampusData={selectedCampusData}
                optionsCampus={procedureSelectedInfo?.detail?.campusApplied}
                options={optionsList?.map((p: any) => ({
                  value: p.id,
                  label: p.name
                }))}
                optionsTurns={turnList?.map((p: any) => ({
                  value: p.id,
                  label: TextHelper.capitalize(p.name, false, true)
                }))}
                // options={procedureSelectedInfo?.detail.studiesOptionList?.map(
                //   (p: any) => ({
                //     value: p.id,
                //     label: p.name
                //   })
                // )}
                optionsPeriod={procedureSelectedInfo?.detail?.periodApplied?.map(
                  (p: any) => ({
                    value: p.id,
                    label: p.name
                  })
                )}
                currentModality={
                  procedureSelectedInfo?.detail?.currentAcademicData
                    ?.studiesOption?.modalityCode
                }
                currentCareer={
                  procedureSelectedInfo?.detail?.currentAcademicData
                    ?.studiesOption?.careerName
                }
                changeOption={handlerChangeOption}
                changePeriod={handlerChangePeriod}
                changeCampus={handlerChangeCampus}
                isLoadingModalityOptionList={isLoadingModalityOptionList}
                onSubmit={handlerRequest}
                handlerChangeCycle={handlerChangeCycle}
                selectedTurn={selectedTurn}
                isEntering={isEntering}
              />
            </Step>
            <Step
              name={procedureSelectedInfo?.steps[1]?.name}
              order={procedureSelectedInfo?.steps[1]?.order}
              disabled
              isLast
            />
          </Block>
        </SubContainer>
      )}
      <Processing isOpen={isProcessing} />

      <ModalConfirmation
        show={confirmRequest && !isProcessing}
        handleClose={() => {
          setConfirmRequest(false);
        }}
      >
        <ConfirmRequestComponent
          handlerCloseModalConfirmRequest={handlerCloseModalConfirmRequest}
          handlerSendData={handlerSendData}
          modalityName={selectedOption?.label}
          careerName={TextHelper.capitalize(
            procedureSelectedInfo?.detail?.currentAcademicData?.studiesOption
              ?.careerName,
            true
          )}
          currentModalityName={TextHelper.capitalize(
            procedureSelectedInfo?.detail?.currentAcademicData?.studiesOption
              ?.modalityCode,
            true
          )}
          selectedPeriod={selectedPeriod}
        />
      </ModalConfirmation>

      <ModalConfirmation
        show={showAlertBack}
        handleClose={() => {
          setShowAlertBack(false);
        }}
      >
        <ConfirmationQuit
          handleQuit={() => history.goBack()}
          handleCancel={() => setShowAlertBack(false)}
        />
      </ModalConfirmation>

      <ModalConfirmation
        show={isEnrolled}
        handleClose={() => goToProcedureHome()}
      >
        <EnrolledComponent
          selectedPeriod={selectedPeriod}
          listCourses={listCourses}
          isEnrolled={isEnrolled}
          handleCloseModal={handleCloseModalIsInrolled}
        />
      </ModalConfirmation>

      <ModalConfirmation
        show={isRequestLimit}
        handleClose={() => goToProcedureHome()}
      >
        <EnrolledComponent
          selectedPeriod={selectedPeriod}
          listCourses={listCourses}
          isEnrolled={isEnrolled}
          isRequestLimit={isRequestLimit}
          handleCloseModal={handleCloseModalIsRequestLimit}
        />
      </ModalConfirmation>

      <ModalConfirmation
        show={isRequestLimitAndEnrollment}
        handleClose={() => goToProcedureHome()}
      >
        <EnrolledComponent
          selectedPeriod={selectedPeriod}
          listCourses={listCourses}
          isEnrolled={isEnrolled}
          isRequestLimit={isRequestLimit}
          isRequestLimitAndEnrollment={isRequestLimitAndEnrollment}
          handleCloseModal={handleCloseModalIsInrolledAndRequestLimit}
        />
      </ModalConfirmation>

      <ModalConfirmation show={isRegisterError} handleClose={handlerErrorClose}>
        <ContentModalOneButton
          img={iconError}
          title="¡Oh no!<br/>Ha sucedido un error inesperado"
          showInfo={false}
          textButton="Entendido"
          onClickButton={handlerErrorClose}
          style={{ textAlign: 'center', color: 'var(--text-text02)' }}
        />
      </ModalConfirmation>

      {/* <ModalConfirmation
        show={processAvailable}
        handleClose={handleCloseModalProcessAvailable}
      >
        <ProcessComponent
          hideImage
          handleClick={handleCloseModalProcessAvailable}
          title={procedureSelectedInfo?.error?.title}
          subtitle={procedureSelectedInfo?.error?.description}
        />
      </ModalConfirmation> */}
    </ContainerProcedure>
  );
};

export default ChangeStudiesOptionRegisterView;
